// Angular Core
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const authGuard: CanActivateFn = (route, state) => {
  let router = inject(Router)
  let userToken = sessionStorage.getItem('access_token')

  if(userToken) {
    return true
  }

  router.navigate(['/login'])
  return false
};
